import styled from 'styled-components';

import * as colors from '../../shared/colors';

export const Button = styled.button`
    background: none;
    color: ${colors.text};
    border: 1.5px solid ${colors.text};
    font-size: 1rem;
    padding: 0.5rem 0.5rem;
    border-radius: 0.65rem;

    &:hover, &:focus, &:active, &:visited {
        background: none;
        color: ${colors.text};
    }

    &[disabled] {
        background: none;
        color: ${colors.unlight};
        border-color: ${colors.unlight};
    }
`;

export const StyledForm = styled.form`
    margin: 0 1rem;
    label {
        text-indent: 0.5rem;

        small {
            text-indent: 0;
        }
    }

    @media (max-width: 650px) {
        label.inline {
            margin: 0;
            padding-bottom: 0;
        }
    }

    input, select {
        border: 1px solid ${colors.text};
        box-shadow: none;
        border-radius: 0.65rem;
    }

    .error {
        input {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
        }

        small.error {
            border-bottom-left-radius: .64rem;
            border-bottom-right-radius: .64rem;
            border: 1px solid ${colors.text};
            border-top: none;
        }
    }
`;
